import React from 'react';
import { Construction, Zap, Settings } from 'lucide-react';

const PlaceholderView = ({ title, description, icon: IconComponent, comingSoon = true }) => {
  const Icon = IconComponent || Construction;

  return (
    <div className="flex flex-col items-center justify-center h-96 text-center">
      <div className="p-6 bg-gray-100 rounded-full mb-6">
        <Icon className="h-16 w-16 text-gray-500" />
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
      
      <p className="text-gray-600 mb-6 max-w-md">
        {description || `This ${title.toLowerCase()} section is under development and will be available soon.`}
      </p>
      
      {comingSoon && (
        <div className="flex items-center space-x-2 text-blue-600">
          <Zap className="h-5 w-5" />
          <span className="font-medium">Coming Soon</span>
        </div>
      )}
      
      {!comingSoon && (
        <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors flex items-center">
          <Settings className="h-5 w-5 mr-2" />
          Configure Now
        </button>
      )}
    </div>
  );
};

export default PlaceholderView;